export enum UsersRoutes {
  CreateOne = 'create-one',
  Search = 'search',
  UpdateOne = 'update-one',
  UpdateSelf = 'update-self',
}
